import React, { type FC } from 'react';
import { graphql, useFragment } from 'react-relay';
import type { rowsContentRenderer_nativeIssueTable$key } from '@atlassian/jira-relay/src/__generated__/rowsContentRenderer_nativeIssueTable.graphql';
import { useCustomComponents } from '../../../controllers/custom-components/index.tsx';

export type RowsContentRendererProps = {
	depth: number;
	groupId?: string;
	issues: rowsContentRenderer_nativeIssueTable$key;
};

export const RowsContentRenderer: FC<RowsContentRendererProps> = ({ depth, groupId, issues }) => {
	const { RowsContent } = useCustomComponents();

	const issuesData = useFragment(
		graphql`
			fragment rowsContentRenderer_nativeIssueTable on JiraIssueConnection {
				__typename
			}
		`,
		issues,
	);

	return RowsContent && <RowsContent depth={depth} groupId={groupId} issues={issuesData} />;
};
